import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Public, Private } from './Components/Auth/Auth';
import { CheckForInActivity, HandleLogout, UpdateExpiryTime } from './common/Logout';
import { isLoggedin } from './common/GetUserData';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContextProvider } from './context/ContextProvider';
import LoadingSpin from './common/Spinner';
import Reports from './Components/Reports/Reports';
import SubscriptionForm from './Components/Subscribers/SubscriptionForm'
import SubscriberApproval from './Components/Subscribers/SubscriberApproval'
import SqsStatus from './Components/SqsStatus/SqsStatus';
import { useMutation, useQuery } from "react-query";
import {GetUsers} from './API/Axios';
const Login = lazy(() => import('./Components/Login/Login'));
const Notifications = lazy(() => import('./Components/Notifications/Notifications'));
const Dashboard = lazy(() => import('./Components/Dashboard/Dashboard'));
const UploadCSV = lazy(() => import('./Components/SendBulk/UploadCSV'));
const VendorSwitch = lazy(() => import('./Components/VendorSwitch/VendorSwitch'));
const SendBulk = lazy(() => import('./Components/SendBulk/SendBulk'));
const SideMenu = lazy(() => import('./Components/Menu/SideMenu'));
const Profile = lazy(() => import('./Components/Profile/Profile'));
const Bitmap = lazy(() => import('./Components/Bitmaps/Bitmap'));
const PortalBlockedNumbers = lazy(() => import('./Components/BlockedNumbers/BlockedNumbers'));
const SmsBlockedNumbers = lazy(() => import('./Components/BlockedNumbers/SmsBlockedNumbers'));
const Logs = lazy(() => import('./Components/Logs/Logs'));
const ManageRoles = lazy(() => import('./Components/ManageRoles/ManageRoles'));
const BulkReqTable = lazy(() => import('./Components/BulkReqTable/BulkReqTable'));
const ManagesUser = lazy(() => import('./Components/ManageUsers/ManagesUser'));
const TemplateApproval = lazy(()=>import('./Components/Templates/TemplateApproval'));
const UserMenus = lazy(()=>import('./Components/UserMenus/UserMenus'));
const BitmapDecode = lazy(()=>import('./Components/Bitmaps/DecodeBitmap'));
const AddTimeline = lazy(()=>import('./Components/Timeline/AddTimeline'));
const MsgTemplates = lazy(()=>import('./Components/MsgTemplates/MsgTemplates'));
 
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(isLoggedin());
  const [RoutesData, setRoutes] = useState([]);
  const { logout, setLogout } = useContextProvider();
  useEffect(() => {
    if (isLoggedIn) {
      const interval = setInterval(() => {
        CheckForInActivity();
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      UpdateExpiryTime();
      ['click', 'keypress', 'scroll', 'mousemove'].forEach((event) => {
        window.addEventListener(event, UpdateExpiryTime);
      });

      return () => {
        ['click', 'keypress', 'scroll', 'mousemove'].forEach((event) => {
          window.removeEventListener(event, UpdateExpiryTime);
        });
      };
    }
  }, [isLoggedIn]);

  const { data: usersData, refetch: refetchUsers, isFetching: isFetchingUsers } = useQuery(
      ['getUsers'], 
      () => GetUsers(), 
      {
          refetchOnWindowFocus: false, 
          select: (res) => {
            const user = res.find((item) => item.UserName === sessionStorage.getItem('username'));
            if (user) {
              sessionStorage.setItem('userId', user.UserId);
            }                  
            return res; 
          },
          onError: (error) => {
              console.error(error);
          },
      }
  );
    
  const logoutMutation = useMutation(
    async (userLoginRequest) => {
      const response = await fetch('https://itpgateway.link/apis/iportal/Logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userLoginRequest)
      });
      if (!response.ok) {
        throw new Error('Failed to logout');
      }
      return response.json();
    },
    {
      onError: (error) => {
        console.error('Error logging out:', error);
      },
      onSuccess: (data) => {
        console.log('Logout successful:', data);
      }
    }
  );
  useEffect(() => {
    const handleTabClose = (event) => {
      const userLoginRequest = {
        USERNAME: sessionStorage.getItem('userId'),
        PASSWORD: ""
      };
      logoutMutation.mutate(userLoginRequest);
    };
    window.addEventListener('unload', handleTabClose);
    return () => {
      window.removeEventListener('unload', handleTabClose);
    };
  }, [logoutMutation]);

  const getComponents = (ID) => {
    switch (ID) {
      case 1: return <Dashboard />;
      case 2: return <Notifications />;
      case 3: return <></>;
      case 4: return <></>;
      case 5: return <SendBulk />;
      case 6: return <UploadCSV />;
      case 7: return <VendorSwitch />;
      case 8: return <Bitmap />;
      case 9: return <PortalBlockedNumbers />;
      case 10: return <SmsBlockedNumbers />;
      case 11: return <BulkReqTable />;
      case 12: return <Logs />;
      case 13 : return <ManageRoles />
      case 14 : return <ManagesUser />
      case 15 : return <Reports />
      case 18 : return <TemplateApproval/>
      case 19 : return <SubscriberApproval/>
      case 20 : return <MsgTemplates/>
      case 21 : return <SqsStatus/>
      case 22 : return <UserMenus/>
      case 23 : return <AddTimeline/>
      case 24 : return <BitmapDecode/>
      default: return <h1>Not Found</h1>;
    }
  };

  return (
    <>
    <ToastContainer />
    {logout && <LoadingSpin height={'100vh'} />}
    <Router>
      <div className={logout ? "d-none" : "d-flex"}>
        {isLoggedIn && <div id='sidemenu'>
          <SideMenu setRoutes={setRoutes} />
        </div>}
        <div style={{ width: "100%", overflowY: 'auto', flex: 1 }}>
          <Routes>
            <Route element={<Public />}>
              <Route path='/' element={<Login />} />
            </Route>
            <Route element={<Private />}>
              {RoutesData.map((eachRoute) => (
                <Route key={eachRoute.ID} path={btoa(eachRoute.URL)} element={<Suspense fallback={<LoadingSpin height={'100vh'} />}>{getComponents(eachRoute.ID)}</Suspense>} />
              ))}
              <Route path='/profile' element={ <Suspense fallback={<LoadingSpin height={'100vh'} />}>{<Profile />} </Suspense> } />
            </Route>
          </Routes>
        </div>
      </div>
    </Router>
  </>
  
  );
}

export default App;
